import {
  activateClickTarget,
  activateFocusTrap,
  getFocusTrapStops,
  releaseBackgroundFocus,
  trapTabWithinContainer,
} from '../utils/keyboard-focus.util';

export const GROUP_NUMBER_POPUP_SELECTOR = '.signupbox.groupnumber .Signup_login';
export const GROUP_NUMBER_POPUP_TAB_ATTR = 'data-details-tab';

export function openGroupNumberFocusTrap(): void {
  activateFocusTrap(GROUP_NUMBER_POPUP_SELECTOR, GROUP_NUMBER_POPUP_TAB_ATTR);
}

export function closeGroupNumberFocusTrap(): void {
  releaseBackgroundFocus();
}

export function onGroupNumberActionKeydown(event: KeyboardEvent): void {
  activateClickTarget(event);
}

export function onGroupNumberDocumentTabKeydown(event: KeyboardEvent): void {
  if (event.key !== 'Tab') {
    return;
  }

  const container = document.querySelector(GROUP_NUMBER_POPUP_SELECTOR);
  if (!(container instanceof HTMLElement)) {
    return;
  }

  const stops = getFocusTrapStops(container, GROUP_NUMBER_POPUP_TAB_ATTR);
  if (stops.length === 0) {
    return;
  }

  const active = document.activeElement as HTMLElement;
  if (!container.contains(active)) {
    event.preventDefault();
    (event.shiftKey ? stops[stops.length - 1] : stops[0]).focus();
    return;
  }

  trapTabWithinContainer(event, container, stops);
}
